import { render, staticRenderFns } from "./hrcoreInfo.vue?vue&type=template&id=5587e3a4&scoped=true&"
import script from "./hrcoreInfo.vue?vue&type=script&lang=ts&"
export * from "./hrcoreInfo.vue?vue&type=script&lang=ts&"
import style0 from "./hrcoreInfo.vue?vue&type=style&index=0&id=5587e3a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5587e3a4",
  null
  
)

export default component.exports